import {
  getHistoryDetails,
  // getMarketingConsent,
  getPolicyStartDate,
  getPromoCode,
  getRecentInsurer,
  hasAgreedTermsAndConditions,
  hasBreakInClaims,
  samePostalAddress,
} from 'scenes/landlord/selectors';
import { LandlordFunnelState } from 'scenes/landlord/types';
import { marshalQuoteDates } from 'scenes/common/api/quote/marshaller/dates';
import {
  toUsedDifferentAddress,
  toWireAgreedTc,
  toWireEmailOptIn,
  toWireHistory,
  // toWireMarketingConsent,
  toWireOnlineDiscount,
  toWirePromoCode,
} from 'scenes/common/api/quote/marshaller/policy';
import { WireNameValue } from 'scenes/common/api/quote/types';

import { partyRefIds } from './party';
import { assetRefIds } from './assets';
import { WireLandlordPolicyCreateRequest } from '../types';

const toWirePolicyOtherAttributes = (
  state: LandlordFunnelState
): WireNameValue[] => [
  ...toWireOnlineDiscount(),
  ...toWireAgreedTc(hasAgreedTermsAndConditions(state)),
  ...toWireEmailOptIn(),
  ...toWirePromoCode(getPromoCode(state)),
  // ...toWireMarketingConsent(getMarketingConsent(state)),
  ...toUsedDifferentAddress(!samePostalAddress(state)),
];

export const toWirePolicy = (
  state: LandlordFunnelState
): WireLandlordPolicyCreateRequest => ({
  dates: marshalQuoteDates(getPolicyStartDate(state)),
  partyRefId: partyRefIds(state),
  assetRefIds: assetRefIds(state),
  history: toWireHistory(
    getRecentInsurer(state),
    hasBreakInClaims(state),
    getHistoryDetails(state)
  ),
  otherAttributes: toWirePolicyOtherAttributes(state),
});
